import { useEffect, useRef, useState } from "react";
import QrScanner from "qr-scanner";
import { Spinner } from "react-bootstrap";

const QRCodeScanner = ({ onScanComanda }) => {
  const scanner = useRef();
  const videoEl = useRef();
  const [qrOn, setQrOn] = useState(true);
  const [qrData, setQrData] = useState(null);

  const onScanFail = (err) => {
    // console.log(err);
  };

  const onScanSuccess = (result) => {
    if (result.data && qrData === null) {
      setQrData(result.data);
    }
  };

  useEffect(() => {
    if (qrData) {
      onScanComanda(qrData);
    }
  }, [qrData, onScanComanda]);

  useEffect(() => {
    const curVideoEl = videoEl?.current;

    if (curVideoEl && !scanner.current) {
      scanner.current = new QrScanner(curVideoEl, onScanSuccess, {
        onDecodeError: onScanFail,
        preferredCamera: "user", //environment
        highlightScanRegion: true,
        highlightCodeOutline: true,
      });

      scanner?.current
        ?.start()
        .then(() => setQrOn(true))
        .catch((err) => {
          if (err) setQrOn(false);
        });
    }

    return () => {
      scanner?.current?.stop();
    };
  }, []);

  useEffect(() => {
    if (!qrOn)
      alert(
        "Camera is blocked or not accessible. Please allow camera in your browser permissions and Reload."
      );
  }, [qrOn]);

  if (qrData) {
    return (
      <div className="d-flex justify-content-center mb-5">
        <Spinner animation="border my-5 totem-checkout-spinner" />
      </div>
    );
  }

  return (
    <div id="video-container">
      <video id="qr-video" ref={videoEl}></video>
    </div>
  );
};

export default QRCodeScanner;
